import React, { Fragment } from "react";
import { useNavigate } from "react-router-dom";
import BackButton from "../BackButton";
import SkipButton from "../SkipButton";
import Figure from "../Figure";
import PageBottomContent from "../PageBottomContent";

const RegistrationTemplate = (props) => {
  const navigate = useNavigate();

  const {
    containerName,
    sectionName,
    configs,
    headerLogo = false,
    footer = true,
    goBack = false,
    footerLogo = false,
    navigationPath = null,
    customMessage = "",
    skipBtn = false,
    onBack = null,
  } = props;

  const { footerText } = configs || { footerText: "" };
  return (
    <Fragment>
      {goBack && (
        <BackButton
          text="Back"
          onClick={() => {
            if (onBack) {
              onBack();
            } else {
              return onBack
                ? onBack()
                : navigationPath
                ? navigate(navigationPath)
                : navigate(-1);
            }
          }}
        />
      )}
      {skipBtn && (
        <SkipButton text="skip" skipTo={() => window.history.go(-1)} />
      )}
      <section className={`${containerName}__section ${sectionName}`}>
        <Figure
          className={`${containerName}`}
          {...configs}
          logo={headerLogo}
          customMessage={customMessage}
        />
        {props.children}
      </section>
      {footer && (
        <footer className={`${containerName}__footer`}>
          <PageBottomContent text={footerText} logo={footerLogo} />
        </footer>
      )}
    </Fragment>
  );
};

export default RegistrationTemplate;
